import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { referralTemplatesLoad } from '../../../redux/actions/referralActions';
import ReferralTemplatesModal from './ReferralTemplatesModal';
import { Field } from 'redux-form';
import { Input, Textarea, PhoneInput, RadioGroup, AutoCompleteList, DatePicker } from '../../../itrust_common/components/form';
import { lowercase } from '../../../itrust_common/components/form/FormNormalize';

let ReferralDeatilsForm = props => {
  const { defaultContacts, change, staffId } = props;
  const dispatch = useDispatch();
  const templatesFromStore = useSelector(state => state.referral.templates);
  const templates = Array.isArray(templatesFromStore) ? templatesFromStore : [];
  const [selectedTemplateId, setSelectedTemplateId] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fetchTemplates = () => {
    dispatch(referralTemplatesLoad({rpp: 99, filter: { category: 'referrals', is_enabled: true, staff_id : staffId }}));
  };

  useEffect(() => {
    fetchTemplates();
  }, [dispatch]);

  const handleTemplateChange = (e) => {
    const val = e.target.value;
    setSelectedTemplateId(val);
    const template = templates.find(t => t.id.toString() === val);
    if (template && change && template.configuration) {
      if (template.configuration.request_to_see?.value) change('request_to_see', template.configuration.request_to_see.value);
      if (template.configuration.referral_reason?.value) change('referral_reason', template.configuration.referral_reason.value);
      if (template.configuration.body_message?.value) change('body_message', template.configuration.body_message.value);
    }
  };

  const handleClearTemplate = () => {
    setSelectedTemplateId('');
    if (change) {
      change('request_to_see', '');
      change('referral_reason', '');
      change('body_message', '');
    }
  };

  // Group templates by template_category
  const groupedTemplates = templates.filter(t => t.active !== false && t.is_enabled !== false).reduce((acc, template) => {
    const category = template.configuration?.template_category || 'Other';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(template);
    return acc;
  }, {});

  return (
    <div>
      <ReferralTemplatesModal 
        isOpen={isModalOpen} 
        onClose={() => {
          setIsModalOpen(false);
          fetchTemplates();
        }} 
        templates={templates}
        fetchTemplates={fetchTemplates} 
      />
      <div className="row mb-4">
        <div className="col-12">
          <label className="font-weight-bold">Referral / Note Template <span className="text-muted font-weight-normal">(optional)</span></label>
          <div className="d-flex align-items-center">
            <select 
              className="custom-select mr-3" 
              value={selectedTemplateId} 
              onChange={handleTemplateChange}
              style={{ maxWidth: '600px' }}
            >
              <option value="">Select a template...</option>
              {Object.keys(groupedTemplates).map(category => (
                <optgroup key={category} label={category}>
                  {groupedTemplates[category].map(t => (
                    <option key={t.id} value={t.id}>{t.name}</option>
                  ))}
                </optgroup>
              ))}
            </select>
            <button type="button" className="btn btn-outline-primary mr-2" onClick={handleClearTemplate}>Clear</button>
            <button type="button" className="btn btn-outline-primary text-nowrap" onClick={() => setIsModalOpen(true)}>Manage Templates</button>
          </div>
          <div className="small text-muted mt-2">
            Applies Request to See, Referral Reason and Body Message. All fields remain editable. Templates do not change the checklist.
          </div>
        </div>
      </div>
      <span className="font-weight-bold">Referral Detail</span>
      <div className="row mt-5">
        <Field name="name" component={Input} placeholder="Placeholder" wrapperClasses="col-6 form-group" className="form-control disabled bg-light" label="Patient Name"/>
        <Field name="referral_date" component={DatePicker} placeholder="Placeholder" wrapperClasses="col-6 form-group" className="disabled bg-light" label="Referral Date"/>
        <Field name="date_of_birth" component={Input} placeholder="Placeholder" wrapperClasses="col-6 form-group" className="form-control disabled bg-light" label="Date Of Birth"/>
        <Field name="age" component={Input} placeholder="Placeholder" className="form-control disabled bg-light" wrapperClasses="col-6 form-group" label="Age"/>
        <div className="col-6">
          <label>Cell Phone</label>
          <Field name="cell_phone" component={PhoneInput} placeholder="Placeholder" wrapperClasses="form-group" className="form-control" disabled={true}/>
        </div>
        <Field name="email" normalize={lowercase} component={Input} placeholder="Placeholder" wrapperClasses="col-6 form-group" className="form-control disabled bg-light" label="Email"/>
        <Field name="request_to_see" component={Input} placeholder="Placeholder" wrapperClasses="col-6 form-group" className="form-control" label="Request to See"/>
        <Field name="referral_reason" component={Input} placeholder="Placeholder" wrapperClasses="col-6 form-group" className="form-control" label="Referral Reason"/>
        <Field name="body_message" component={Textarea} rows={5} placeholder="Placeholder" wrapperClasses="col-12 form-group" className="form-control" label="Body Message"/>
        <Field name="contact_ids" 
          label="Secure Fax" 
          placeholder="Search and add contact" 
          component={AutoCompleteList} 
          defaultData={defaultContacts} 
          klass="Contact"
          valueField="id"
          autoCompleteTextField="company_name"
          view={{image:'logo', h5:'company_name', span:'fax'}}
          className="my-5 col-6"
          wrapperClasses="col-8 form-group" />
        <RadioGroup name="send_notification_to_patient" options={[{label: 'Yes', value: true}, {label: 'No', value: false}]} wrapperClasses="col-4 form-group" label="Send Notification to Patient"/>
      </div>
    </div>
  );
}


const mapStateToProps = state => {
  const { exam } = state;
  return {
   staffId: exam.exam?.staff_id
  }
}

export default connect(mapStateToProps)(ReferralDeatilsForm);

